import { useQuery } from "@tanstack/react-query"
import { createContext, useContext, type ReactNode } from "react"
import { api } from "../api/client"

export interface PublicConfig {
  instanceLabel: string | null
  registrationEnabled: boolean
  ready: boolean
}

const fallbackConfig: PublicConfig = {
  instanceLabel: null,
  registrationEnabled: false,
  ready: false
}

const PublicConfigContext = createContext<PublicConfig>(fallbackConfig)

export function PublicConfigProvider({ children }: { children: ReactNode }) {
  const query = useQuery({
    queryKey: ["public-config"],
    queryFn: () => api.get<PublicConfig>("/public/config"),
    staleTime: Number.POSITIVE_INFINITY,
    retry: 2
  })

  return (
    <PublicConfigContext.Provider
      value={query.data ? { ...query.data, ready: true } : { ...fallbackConfig, ready: query.isFetched }}
    >
      {children}
    </PublicConfigContext.Provider>
  )
}

export function usePublicConfig() {
  return useContext(PublicConfigContext)
}
